export default __webpack_public_path__ + "static/media/f_mailto.e6b61691.svg";